var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 15 15",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5923 0H1.40792C0.158759 0 -0.471505 1.51556 0.413554 2.40062L5.15625 7.14498V12.1875C5.15625 12.6301 5.36464 13.0469 5.71875 13.3594L7.59375 14.7383C8.50995 15.3785 9.84375 14.7833 9.84375 13.6133V7.14498L14.5867 2.40062C15.47 1.51734 14.844 0 13.5923 0ZM8.4375 6.5625V13.5938L6.5625 12.1875V6.5625L1.40625 1.40625H13.5938L8.4375 6.5625Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.e6e59c17dab20dc9038e4182e87ac4d9.svg";
export { ForwardRef as ReactComponent };